export const ROLES = [
    {key: "ROLE_CLIENT", label: "Client"},
    {key: "ROLE_ADVISOR", label: "Conseiller"},
    {key: "ROLE_ADMIN", label: "Administrateur"}
];


// WEBPACK FOOTER //
// ./src/utils/constants.js